import {Component, OnDestroy, OnInit} from '@angular/core';
import { FlowChartDataService } from '../../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-workflow-right-side-bar-container',
  templateUrl: './workflow-right-side-bar-container.component.html',
  styleUrls: ['./workflow-right-side-bar-container.component.scss']
})
export class WorkflowRightSideBarContainerComponent implements OnInit, OnDestroy {
  section: any={};
  constructor(public flowChartDataService: FlowChartDataService) {
    this.section.id = '5c122f40de06a26f99ce2195f22b7cea';
    this.section.flowchartId='61ce9a5bd35ccfdff2976d8ff1eeba98';

  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.flowChartDataService.destroy();
  }

}
